import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { XMarkIcon } from '@heroicons/react/24/outline';

import { IconButton } from '../../ui/IconButton';

import { CommunityIdentity } from '../../CommunityIdentity';

interface MobileDrawerHeaderProps {
  onClose: () => void;
}

export const MobileDrawerHeader: FC<MobileDrawerHeaderProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3 p-4">
      <CommunityIdentity />
      <IconButton aria-label={t('shared.close')} className="shrink-0" onClick={onClose}>
        <XMarkIcon className="size-5" strokeWidth={1.6} />
      </IconButton>
    </div>
  );
};
